import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { api } from "../api";
import "../CSS/Auth.css";
import Footer from "../Home/Footer";

const SignUp = () => {
  const [userName, setUserName] = useState('');
  const [email, setEmail] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [password, setPassword] = useState('');
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  const validateForm = () => {
    const newErrors = {};

    if (!userName.trim()) {
      newErrors.userName = "Username is required.";
    } else if (userName.length < 3) {
      newErrors.userName = "Username must be at least 3 characters.";
    }

    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!/^\S+@\S+\.\S+$/.test(email)) {
      newErrors.email = "Enter a valid email address.";
    }

    if (!phoneNumber.trim()) {
      newErrors.phoneNumber = "Phone number is required.";
    } else if (!/^[6-9]\d{9}$/.test(phoneNumber)) {
      newErrors.phoneNumber = "Enter a valid 10-digit Indian phone number.";
    }

    if (!password) {
      newErrors.password = "Password is required.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSignUp = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    const formData = {
      userName,
      email,
      phoneNumber: `+91${phoneNumber}`,
      password,
      role: 'user'
    };

    try {
      const res = await api.post("/auth/signup", formData);
      if (res.data.success) {
        toast.success("Sign Up Successful!", { autoClose: 2000 });
        setTimeout(() => navigate('/login'), 2500);
      } else {
        toast.error(res.data.message || "Sign Up failed.");
      }
    } catch (error) {
      toast.error("Something went wrong. Please try again.");
    }
  };

  return (
    <>
      <div className="auth-container">
        <ToastContainer position="top-right" />
        <div className="auth-form">
          <h2 className="auth-title">Create Your Account</h2>
          <form onSubmit={handleSignUp} noValidate>
            <div className="input-group">
              <label htmlFor="username">Username</label>
              <input
                type="text"
                id="username"
                placeholder="Enter your username"
                value={userName}
                onChange={(e) => {
                  setUserName(e.target.value);
                  setErrors(prev => ({ ...prev, userName: '' }));
                }}
                className={errors.userName ? 'is-invalid' : ''}
              />
              {errors.userName && <div className="error-msg">{errors.userName}</div>}
            </div>

            <div className="input-group">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                id="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  setErrors(prev => ({ ...prev, email: '' }));
                }}
                className={errors.email ? 'is-invalid' : ''}
              />
              {errors.email && <div className="error-msg">{errors.email}</div>}
            </div>

            <div className="input-group">
              <label htmlFor="phone">Phone Number</label>
              <div className="phone-input-wrapper">
                <span className="country-code">+91</span>
                <input
                  type="tel"
                  id="phone"
                  maxLength={10}
                  placeholder="9876543210"
                  value={phoneNumber}
                  onChange={(e) => {
                    const value = e.target.value.replace(/\D/g, '');
                    setPhoneNumber(value);
                    setErrors(prev => ({ ...prev, phoneNumber: '' }));
                  }}
                  className={errors.phoneNumber ? 'is-invalid' : ''}
                />
              </div>
              {errors.phoneNumber && <div className="error-msg">{errors.phoneNumber}</div>}
            </div>

            <div className="input-group">
              <label htmlFor="password">Password</label>
              <div className="password-wrapper">
                <input
                  type={passwordVisible ? "text" : "password"}
                  id="password"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => {
                    setPassword(e.target.value);
                    setErrors(prev => ({ ...prev, password: '' }));
                  }}
                  className={errors.password ? 'is-invalid' : ''}
                />
                <span
                  className="toggle-password"
                  onClick={() => setPasswordVisible(!passwordVisible)}
                  title={passwordVisible ? "Hide password" : "Show password"}
                >
                  {passwordVisible ? <FaEyeSlash /> : <FaEye />}
                </span>
              </div>
              {errors.password && <div className="error-msg">{errors.password}</div>}
            </div>

            <button type="submit" className="auth-btn">Sign Up</button>
          </form>

          <div className="account-message">
            <p>
              Already have an account?{" "}
              <span onClick={() => navigate('/login')} className="link-text">
                Login here
              </span>
            </p>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SignUp;
